import Modal from "react-bootstrap/Modal";
import { BsPlusCircleFill } from "react-icons/bs";
import React from "react";
import { AddEditFacility } from "../components/AddEditFacility";

export const AddEditFacilityModal = ({
  visible,
  close,
  onComplete,
  trust,
  facility = null,
}) => {
  const selectModalName = () => {
    if (facility) {
      return "Edit Facility";
    } else {
      return "Add Facility";
    }
  };
  const modalTitle = selectModalName();
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="modal-title"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            <BsPlusCircleFill /> {modalTitle}
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AddEditFacility
          close={close}
          onComplete={onComplete}
          selectedTrust={trust}
          facility={facility}
        />
      </Modal.Body>
    </Modal>
  );
};
